import { IconDefinition, IconStyle } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

// A known client type shows a building (business) or a person (individual); without one the
// generic clients glyph stands in.
export default function getClientTypeIcon(
    clientTypeLabel: Client["client_type_label"] | undefined,
    style: Extract<IconStyle, "solid" | "regular"> = "solid",
): IconDefinition {
    if (clientTypeLabel === "Business") {
        return faIcon({ name: "building", style })
    } else if (clientTypeLabel === "Individual") {
        return faIcon({ name: "user", style })
    } else {
        return faIcon({ name: "building-user", style })
    }
}
